<template>
  <div id="app">
    <LoadingBar :isLoading="isLoaderActive" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingBar from "@/components/general/LoadingBar.vue";

export default {
  name: "AdGame",
  components: { LoadingBar },
  computed: {
    ...mapGetters(["isLoaderActive"]),
  },
};
</script>

<style lang="scss">
@import "@/style/main.scss";
</style>
